import React from "react";
import "./Nav.scss";
import { NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { handleLogoutRedux } from "../../redux/actions/userAction";
import { AppsIcon, ChartBarIcon, InfoIcon, LogoutIcon } from "../icons";

function Nav(props) {
  const dispatch = useDispatch();
  const account = useSelector((state) => state.user.account);

  if (account.auth !== true) {
    return null;
  }

  return (
    <div className="sidebar">
      <div className="sidebar-brand">
        <div className="sidebar-brand-mark">M</div>
        <span>MDTeam Console</span>
      </div>
      <nav className="sidebar-nav">
        <NavLink to="/admin" exact className="sidebar-nav-link" activeClassName="active">
          <AppsIcon />
          App Manager
        </NavLink>
        <NavLink to="/users" exact className="sidebar-nav-link" activeClassName="active">
          <ChartBarIcon />
          Analytics
        </NavLink>
        <NavLink to="/about" exact className="sidebar-nav-link" activeClassName="active">
          <InfoIcon />
          About
        </NavLink>
      </nav>
      <div className="sidebar-footer">
        {account.email && <div className="sidebar-user-email">{account.email}</div>}
        <button
          type="button"
          className="sidebar-logout-btn"
          onClick={() => dispatch(handleLogoutRedux())}
        >
          <LogoutIcon />
          Đăng xuất
        </button>
      </div>
    </div>
  );
}

export default Nav;
